import bindNode from './bindnode/index.js';
import apply from './_helpers/apply.js';
export default function bindOptionalNode() {
  // this hack allows to keep bindOptionalNode as compact as possible
  // and doesn't require to flip args and support all bindNode variations
  bindNode.temporaryOptionalFlag = true;
  return apply(bindNode, this, arguments);
}